/**
 * Teacher Management Routes
 * Routes for the dedicated Teachers section under People
 */

import { lazy } from "react";
import { RouteObject } from "react-router-dom";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { AppShell } from "@/components/layout/AppShell";
import { LazyPage } from "../helpers";

const TeachersListPage = lazy(() => import("@/pages/teachers/TeachersListPage").then(m => ({ default: m.TeachersListPage })));
const TeacherFormPage = lazy(() => import("@/pages/teachers/TeacherFormPage").then(m => ({ default: m.TeacherFormPage })));
const TeacherDetailPage = lazy(() => import("@/pages/teachers/TeacherDetailPage"));

export const teacherRoutes: RouteObject[] = [
  {
    path: "/teachers",
    element: (
      <ProtectedRoute permission="manage:teachers">
        <AppShell>
          <LazyPage><TeachersListPage /></LazyPage>
        </AppShell>
      </ProtectedRoute>
    ),
  },
  {
    path: "/teachers/new",
    element: (
      <ProtectedRoute permission="manage:teachers">
        <AppShell>
          <LazyPage><TeacherFormPage /></LazyPage>
        </AppShell>
      </ProtectedRoute>
    ),
  },
  {
    path: "/teachers/:id/edit",
    element: (
      <ProtectedRoute permission="manage:teachers">
        <AppShell>
          <LazyPage><TeacherFormPage /></LazyPage>
        </AppShell>
      </ProtectedRoute>
    ),
  },
  {
    path: "/teachers/:id",
    element: (
      <ProtectedRoute permission="manage:teachers">
        <AppShell>
          <LazyPage><TeacherDetailPage /></LazyPage>
        </AppShell>
      </ProtectedRoute>
    ),
  },
];
